export default __webpack_public_path__ + "static/media/hobbit.77a6c016.svg";